import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-actions',
  templateUrl: './edit-actions.component.html',
  styleUrls: ['./edit-actions.component.scss'],
  standalone: false,
})
export class EditActionsComponent {
  @Output() editLimits = new EventEmitter();
  @Output() editPrivacy = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() toggleEnable = new EventEmitter();
  @Output() reconnect = new EventEmitter();

  @Input() isAccountAccessible = false;
  @Input() disabled = false;
  @Input() disableDelete = false;
  @Input() disableReconnect = false;
  @Input() id = '';
  @Input() isAccountEnabled = false;

  toggleSwitcher() {
    this.toggleEnable.emit({ enable: this.isAccountEnabled, id: this.id });
  }
}
